import React from 'react';
import { UserCheck } from 'lucide-react';

interface HealthOwnerFilterProps {
  owners: string[];
  selectedOwner: string;
  onSelectOwner: (owner: string) => void;
}

export const HealthOwnerFilter: React.FC<HealthOwnerFilterProps> = ({
  owners,
  selectedOwner,
  onSelectOwner,
}) => {
  return (
    <div className="flex items-center gap-1.5 bg-gray-50 border border-gray-200 rounded-xl px-2.5 py-1.5 text-xs font-semibold">
      <UserCheck className="w-3.5 h-3.5 text-gray-500 flex-shrink-0" />
      <span className="text-gray-500 font-bold hidden md:inline">Dueño:</span>
      <select
        id="health-owner-select"
        value={selectedOwner}
        onChange={(e) => onSelectOwner(e.target.value)}
        className="bg-transparent text-xs font-bold text-gray-700 outline-none cursor-pointer max-w-[160px] truncate"
      >
        <option value="">Todos los dueños ({owners.length})</option>
        {owners.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </div>
  );
};
